import { useEffect } from 'react';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getExternalTrackingParam, getHasAcq0139TrackingParam, getIsComingFromEmailSignatureGenerator } from './acq0139Utils';
let hasExposureBeenTrackedForAcq0139Cache = false;
export function getHasExposureBeenTrackedForAcq0139() {
  return hasExposureBeenTrackedForAcq0139Cache;
}
export function setHasExposureBeenTrackedForAcq0139() {
  hasExposureBeenTrackedForAcq0139Cache = true;
}
export function resetExposureForAcq0139() {
  hasExposureBeenTrackedForAcq0139Cache = false;
}
export const trackAcq0139ExperimentExposure = () => {
  setHasExposureBeenTrackedForAcq0139();
  const externalTrackingParam = getExternalTrackingParam();
  getTracker().track(EventName.ExperimentExposure, {
    action: externalTrackingParam
  }, true);
};
export const useTrackAcq0139Exposure = () => {
  const exposureHasBeenTracked = getHasExposureBeenTrackedForAcq0139();
  const hasAcq0139TrackingParam = getHasAcq0139TrackingParam();
  const isComingFromEmailSignatureGenerator = getIsComingFromEmailSignatureGenerator();
  useEffect(() => {
    if (hasAcq0139TrackingParam && isComingFromEmailSignatureGenerator && !exposureHasBeenTracked) {
      trackAcq0139ExperimentExposure();
    }
  });
};